import styled from 'styled-components';
import { color, font } from '../../../styles';

export const LandingType = styled.div`
  font-size: ${font.header};
  color: ${color.black};
`;